module.exports = __webpack_public_path__ + "static/img/background.bcad46aa.png";